// extracted by mini-css-extract-plugin
module.exports = {"select-list":"index_select-list__0idW5","select-item":"index_select-item__JtJsD"};